<div class="-oneX-row -oneX-justify-content-center">
    <button tabindex="0" aria-label="Search another claim" (click)="searchAnotherClaim();" role="button" id="search"
      class="-oneX-btn-primary -oneX-btn-fit-content">Search Another Claim</button>
  </div>